import { getSiteId } from './config';

export function getBaseUrl(): string {
  let origin = window.location.origin; 
  if (origin.includes('localhost')) {
    origin = 'https://sis.buldreinfo.com';
  }
  return origin;
}

function getUrl(urlSuffix: string): string {
  return encodeURI(`${getBaseUrl()}/org.jossi.training.jersey.jaxb/v2${urlSuffix}`);
}

function makeAuthenticatedRequest(accessToken: string | null, urlSuffix: string, opts: any) {
  opts = opts || {};
  opts.headers = opts.headers || {};
  opts.mode = 'cors';
  if (accessToken) {
    opts.headers.Authorization = `Bearer ${accessToken}`;
  }
  return fetch(getUrl(urlSuffix), opts);
}

export function getAbout(accessToken: string): Promise<any> {
  return makeAuthenticatedRequest(accessToken, `/about?siteId=${getSiteId()}`, null)
  .then((data) => data.text())
  .catch((error) => {
    console.warn(error);
    return null;
  });
}

export function getAscents(accessToken: string | null, userId: number): Promise<any> {
  return makeAuthenticatedRequest(accessToken, `/ascents?siteId=${getSiteId()}&userId=${userId}`, null)
  .then((data) => data.json())
  .catch((error) => {
    console.warn(error);
    return null;
  });
}

export function getLeaderboard(): Promise<any> {
  return makeAuthenticatedRequest(null, `/leaderboard?siteId=${getSiteId()}`, null)
  .then((data) => data.json())
  .catch((error) => {
    console.warn(error);
    return null;
  });
}

export function getUsersAdmin(accessToken: string): Promise<any> {
  return makeAuthenticatedRequest(accessToken, `/users/admin?siteId=${getSiteId()}`, null)
  .then((data) => data.json())
  .catch((error) => {
    console.warn(error);
    return null;
  });
}

export function getUsers(accessToken: string): Promise<any> {
  return makeAuthenticatedRequest(accessToken, `/users?siteId=${getSiteId()}`, null)
  .then((data) => data.json())
  .catch((error) => {
    console.warn(error);
    return null;
  });
}

export function getMediaList(accessToken: string | null): Promise<any> {
  return makeAuthenticatedRequest(accessToken, `/media/list?siteId=${getSiteId()}`, null)
  .then((data) => data.json())
  .catch((error) => {
    console.warn(error);
    return null;
  });
}

export function getMediaUrl(id: number): string {
  return getUrl(`/media?id=${id}&siteId=${getSiteId()}`);
}

export function getProblems(accessToken: string | null, id: number): Promise<any> {
  return makeAuthenticatedRequest(accessToken, `/problems?id=${id}&siteId=${getSiteId()}`, null)
  .then((data) => data.json())
  .catch((error) => {
    console.warn(error);
    return null;
  });
}

export function postAbout(accessToken: string, xml: any): Promise<any> {
  return makeAuthenticatedRequest(accessToken, `/about?siteId=${getSiteId()}`, {
    method: 'POST',
    body: JSON.stringify({xml}),
    headers: {
      'Content-Type': 'application/json'
    }
  });
}

export function postMediaDelete(accessToken: string, id: number, name: string): Promise<any> {
  return makeAuthenticatedRequest(accessToken, `/media/delete?siteId=${getSiteId()}`, {
    method: 'POST',
    body: JSON.stringify({id, name}),
    headers: {
      'Content-Type': 'application/json'
    }
  });
}

export function postMediaInsert(accessToken: string, filename: string, file: any): Promise<any> {
  const nm = filename.replace(/[^-a-z0-9.]/ig,'_');
  const formData = new FormData();
  formData.append('json', JSON.stringify({filename: nm, name: nm}));
  formData.append(nm, file);
  return makeAuthenticatedRequest(accessToken, `/media/insert?siteId=${getSiteId()}`,{
    method: 'POST',
    body: formData,
    headers: {
      'Accept': 'application/json'
    }
  }).then((data) => data.json());
}

export function postMediaUpdate(accessToken: string, id: number, name: string, hidden: boolean, carouselMedia: boolean): Promise<any> {
  return makeAuthenticatedRequest(accessToken, `/media/update?siteId=${getSiteId()}`, {
    method: 'POST',
    body: JSON.stringify({id, name, hidden, carouselMedia}),
    headers: {
      'Content-Type': 'application/json'
    }
  });
}

export function postProblems(accessToken: string, id: number, mediaId: number, created: any, grade: any, type: any, creator: any, shapes: any, deleted: boolean): Promise<any> {
  return makeAuthenticatedRequest(accessToken, `/problems?siteId=${getSiteId()}`, {
    method: 'POST',
    body: JSON.stringify({id, mediaId, created, grade, type, creator, shapes, deleted}),
    headers: {
      'Content-Type': 'application/json'
    }
  });
}

export function postTicks(accessToken: string | null, id: number, problemId: number, stars: number, grade: string): Promise<any> {
  return makeAuthenticatedRequest(accessToken, `/ticks?siteId=${getSiteId()}`, {
    method: 'POST',
    body: JSON.stringify({id, problemId, stars, grade}),
    headers: {
      'Content-Type': 'application/json'
    }
  }).then((data) => data.json());
}

export function postUsersAdmin(accessToken: string, id: number, name: string, email: string, isAdmin: boolean): Promise<any> {
  return makeAuthenticatedRequest(accessToken, `/users/admin?siteId=${getSiteId()}`, {
    method: 'POST',
    body: JSON.stringify({id, name, email, isAdmin}),
    headers: {
      'Content-Type': 'application/json'
    }
  });
}

export function toggleStar(accessToken: string | null, problemId: number): Promise<any> {
  return makeAuthenticatedRequest(accessToken, `/star?siteId=${getSiteId()}&problemId=${problemId}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    }
  });
}

export function getContestClasses(): Promise<any> {
  return makeAuthenticatedRequest(null, `/contest/classes?siteId=${getSiteId()}`, null)
  .then((data) => data.json())
  .catch((error) => {
    console.warn(error);
    return null;
  });
}

export function getContestClass(accessToken: string): Promise<any> {
  return makeAuthenticatedRequest(accessToken, `/contest/class?siteId=${getSiteId()}`, null)
  .then(response => {
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return response.text();
  })
  .then(text => {
    if (text) {
      return JSON.parse(text);
    } else {
      return null;
    }
  })
  .catch((error) => {
    console.warn(error);
    return null;
  });
}

export function getContestLeaderboard(accessToken: string, classId: number): Promise<any> {
  return makeAuthenticatedRequest(accessToken, `/contest/leaderboard?siteId=${getSiteId()}&classId=${classId}`, null)
  .then((data) => data.json())
  .catch((error) => {
    console.warn(error);
    return null;
  });
}

export function getContestProblems(accessToken: string): Promise<any> {
  return makeAuthenticatedRequest(accessToken, `/contest/problems?siteId=${getSiteId()}`, null)
  .then((data) => data.json())
  .catch((error) => {
    console.warn(error);
    return null;
  });
}

export function postContestProblems(accessToken: string, data: any[]): Promise<any> {
  return makeAuthenticatedRequest(accessToken, `/contest/problems?siteId=${getSiteId()}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  })
  .then((data) => data.json())
  .catch((error) => {
    console.warn(error);
    return null;
  });
}

export function getContestScorecard(accessToken: string, classId: number): Promise<any> {
  return makeAuthenticatedRequest(accessToken, `/contest/scorecard?siteId=${getSiteId()}&classId=${classId}`, null)
  .then((data) => data.json())
  .catch((error) => {
    console.warn(error);
    return null;
  });
}

export function setContestClass(accessToken: string, classId: number): Promise<any> {
  return makeAuthenticatedRequest(accessToken, `/contest/class?siteId=${getSiteId()}&classId=${classId}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    }
  });
}

export function setContestTick(accessToken: string, classId: number, problemId: number, zone: boolean, top: boolean): Promise<any> {
  return makeAuthenticatedRequest(accessToken, `/contest/tick?siteId=${getSiteId()}&classId=${classId}&problemId=${problemId}&zone=${zone}&top=${top}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    }
  })
  .then((data) => data.json());
}

export function getMe(accessToken: string): Promise<any> {
  return makeAuthenticatedRequest(accessToken, `/me?siteId=${getSiteId()}`, null)
  .then((data) => data.json())
  .catch((error) => {
    console.warn(error);
    return null;
  });
}

export function postMe(accessToken: string, name: string): Promise<any> {
  return makeAuthenticatedRequest(accessToken, `/me?siteId=${getSiteId()}`, {
    method: 'POST',
    body: JSON.stringify({ name }),
    headers: {
      'Content-Type': 'application/json'
    }
  });
}

export function deleteContestUserTicks(accessToken: string, userId: number): Promise<any> {
  return makeAuthenticatedRequest(accessToken, `/contest/delete_user_ticks?siteId=${getSiteId()}&userId=${userId}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    }
  });
}